import { FormValidator } from './FormValidator';
import { cart } from '../Cart/Cart';
/* eslint-disable */
let status = {
  step1: false,
  step2: false,
  step3: false,
};

/**
 * Form stepper is used in EXT, HWB, BL, Elm, COT and School
 */
export class FormStep {
  constructor() {
    this.$form = $('#ext-order-form, #school-order-form, #hwb-order-form, #bl-order-form');
    if (this.$form.length === 0) {
      return;
    }

    this.$step = $('.js-checkout-step');
    this.$steps = $('.js-checkout-stepBox');
    this.$stepFirst = $('.js-checkout-stepBox-1');
    this.invoiceAddress = $('.js-checkout-toggle-factuuradres');
    this.$progressNav = $('.checkout__progress-steps');
    this.$toStep2 = $('#to-step-2');
    this.$btnPayment = this.$form.find('button[type="submit"]');
    this.$profileType = $('input[name="profile_type"]');
    this.$errors = $('.form-errors');
    this.$errorContainer = $('.form-error-container');
    this.$errorMessageList = $('.form-errors ul');

    // init form
    this.validator = new FormValidator(this.$form);
    this.$steps.hide();
    this.$stepFirst.show();

    // Bind events
    this.$step.on('click', e => this.goto(e));
    this.invoiceAddress.on('click', e => this.toggleFactuuradres(e));
    this.$progressNav.on('click', '.checkout__step_done', e => this.goto(e));
    this.$btnPayment.on('click', e => this.onSubmit(e));
    this.$profileType.on('change', e => this.toggleStudentFields(e));
    this.$form.on('keypress', e => e.which !== 13); // prevent form submit when enter is pressed
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.validator.check.form()) {
      if (this.$form.attr('id') === 'ext-order-form') {
        this.submitExamTrainingForm();
      } else {
        // FormValidator class will append loading icon
        this.$form.submit();
      }
    }
  }

  goto(e) {
    let step = isNaN(e) ? $(e.currentTarget).data('goto') : e;
    this.goToStep(step);
  }

  /**
     * Displays the right step in the checkout flow
     */
  goToStep(goto) {
    this.$steps.hide();
    $('.js-checkout-stepBox-'+goto).show();
    this.$progressNav.removeClass('checkout__step_active');
    $('.checkout__buttons').removeClass('checkout__buttons-step-1').removeClass('checkout__buttons-step-2').addClass('checkout__buttons-step-'+goto);
    if (goto === 2){
      $('.checkout__payment-info').show();
    }
    else {
      $('.checkout__payment-info').hide();
    }

    this.validator.hideErrors();

    // Update step progress
    // loop through the stepper navigation
    for (let i = 1; i < 4; i++) {
      // Mark previous step as 'done'
      status['step'+i] = (i <= goto - 1);

      // Update step status
      if (status['step'+i]) {
        $('.js-checkout-progress-step-'+i).addClass('checkout__step_done');
      } else {
        $('.js-checkout-progress-step-'+i).removeClass('checkout__step_done').removeClass('checkout__step_active');
      }
    }
    $('.js-checkout-progress-step-'+goto).addClass('checkout__step_active');

    this.scrollTop();
  }

  submitExamTrainingForm() {
    this.$btnPayment.attr('disabled', true);
    this.addLoading(this.$btnPayment);

    const postArguments = {
      action: 'lyceo',
      controller: 'ExamentrainingFormProcessor',
      nonce: ajax_nonce,
      method: 'ajaxRun',
    };

    // add all values of the fields to the postArguments
    $.each(this.$form.serializeArray(), (key, obj) => {
      postArguments[obj.name] = obj.value;
    });

    return $.ajax({
      url: ajax_link,
      method: 'post',
      data: postArguments,
      success: resp => this.handleSubmitExtResponse(resp),
    });
  }

  /**
     * Display the errors from the backend or empty the cart and redirect the user
     * @param response
     */
  handleSubmitExtResponse(response) {
    if (response.errors) {
      this.removeLoading(this.$btnPayment);
      this.scrollTop();

      this.$errors.html($('<ul>'));
      this.$errorMessageList	= $('.form-errors ul');

      if (Array.isArray(response.errors)) {
        $.each(response.errors, (key, message) => {
          this.$errorContainer.show();
          this.$errorMessageList.append('<li>'+ message +'</li>');
        });
      } else if (typeof response.errors === 'string') {
        this.$errorContainer.show();
        this.$errorMessageList.append(response.errors);
      } else if (typeof response.errors === 'object') {
        // do not display this ugly english skoleo error
        delete response.errors.order_type;

        // loop over the errors
        Object.values(response.errors).map(message => {
          this.$errorContainer.show();
          this.$errorMessageList.append('<li>'+ message +'</li>');
        });
      }

    } else { // Success -> Redirect us to the payment page
      setTimeout(() => {
        cart.empty();
        this.redirectTo(response.redirectTo);
      }, 1000);
    }
  }

  /* istanbul ignore next */
  redirectTo(url) {
    window.location.href = url;
  }

  toggleStudentFields(e) {
    if ($(e.currentTarget).val() === 'ouderverz') {
      $('.if-parent').slideDown();
      $('.if-pupil').removeClass('extra-info__show');
    } else {
      $('.if-parent').slideUp();
      $('.if-pupil').addClass('extra-info__show');
    }
  }

  toggleFactuuradres(e) {
    e.preventDefault();
    $('#checkout__factuuradres').slideToggle();
  }

  addLoading($el) {
    $el.append('<i class="fa fa-spinner fa-pulse" style="margin-left: 10px;"></i>');
  }

  removeLoading($el) {
    $el.find('.fa').remove();
    $el.removeAttr('disabled');
  }

  scrollTop() {
    $('html, body').animate(
      { scrollTop: 0 },
      { duration: 500, queue: false }
    );
  }
}
